import { HeaderModel, MessageType, MessagesSet } from '@tencent/dz-models';
import { ImpCoreModel } from './ImpCoreMode';
import { isElementInViewport } from 'src/utils';

export class ImpHeaderModel extends HeaderModel {
  coreModel: ImpCoreModel;

  // 监听元素是否第一次隐藏
  isFirstHide = false;
  listenTimer!: NodeJS.Timeout;

  constructor(coreModel: ImpCoreModel) {
    super();
    this.coreModel = coreModel;
    this.mounted();
  }

  mounted() {
    const consultModel = this.coreModel.getConsultModel();

    if (consultModel.isFullSearch()) {
      const config = consultModel.getConsultConfig();
      this.updateHospital(config.hospital_config);
      this.listenElement();
    }
  }

  // 监听元素
  listenElement() {
    this.listenTimer = setInterval(() => {
      const messageModel = this.coreModel.getMessageModel();
      const message = messageModel.getMessageByType(MessageType.QuestionRecommen);
      if (message) {
        this.handleSingleEle('#guess_question', message);
      }
    }, 1000);
  }

  handleSingleEle(selector: string, message: MessagesSet) {
    const ele = document.querySelector(selector);
    if (!isElementInViewport(ele) && !this.isFirstHide) {
      this.isFirstHide = true;
      // 更新内容 显示顶部卡片
      this.isShowTopCard && this.updateTopCardMessage(message);

      // 取消定时任务
      clearInterval(this.listenTimer);
    }
  };
}
